import EmberRouter from '@ember/routing/router'
import config from 'teacher-ui-client/config/environment'

export default class Router extends EmberRouter {
  location = config.locationType

  rootURL = config.rootURL
}

Router.map(function () {
  this.route('landing', { path: '/' })

  this.route('content-dev')
  this.route('content-preview', function () {
    this.route('printables-set', { path: 'printables-set/:entry_id' })
  })

  this.route('login-cards')

  // reading, maths, writing...
  this.route('subscription-type', { path: '/:subscription_type' }, function () {
    this.route('error404', { path: '/*path' })
    this.route('error-no-students')

    this.route('blog', function () {
      this.route('index', { path: '/' })
      this.route('post', { path: '/:blog_id' })
    })

    this.route('quick-start')
    this.route('home')
    this.route('teacher-home')

    this.route('account')

    this.route('access-expired') // subscription exists but has expired for this sub type (none are active)
    this.route('access-missing') // no subscription at all for this sub type

    this.route('teacher-toolkit', function () {
      // default index route
    })
    this.route('big-books')
    this.route('teacher-resources', { resetNamespace: true }, function () {
      this.route('curriculum-maps')
    })

    this.route('copy-classes')

    this.route('printables')
    this.route('catch-up-guides') // replaces summer school

    this.route('book-library', function () {
      this.route('search')
      this.route('collection', function () {
        this.route('show', { path: '/:collection_id' })
      })
      this.route('shares', function () {
        this.route('new')
        this.route('index', { path: '/' }, function () {
          this.route('by-collection', function () {
            // current or past
            this.route('show', { path: '/:share_id' })
            this.route('edit', { path: '/:share_id/edit' })
          })
          this.route('by-student', function () {
            // all or my students
            this.route('show', { path: '/:student_id' })
          })
        })
      })
    })

    this.route('manage', { resetNamespace: true }, function () {
      this.route('classes', function () {
        this.route('school-class', { path: ':school_class_id' })
      })
      this.route('students', function () {
        this.route('student', { path: ':student_id' })
      })
      this.route('progress')
      this.route('move-students')
      this.route('teachers', function () {
        this.route('teacher', { path: ':teacher_id' })
      })
      this.route('rollover', function () {
        this.route('instructions')
        this.route('wizard')
        this.route('steps', function () {
          this.route('teachers')
          this.route('students', function () {
            this.route('import', function () {
              this.route('validate')
              this.route('invalid')
              this.route('confirm')
              this.route('importing')
              this.route('success')
              this.route('error', { path: '/error/:uuid' })
            })
          })
          this.route('delete-classes')
          this.route('delete-students')
          this.route('finish')
        })
      })
      this.route('import', function () {
        this.route('teachers')
        this.route('students', function () {
          this.route('validate')
          this.route('invalid')
          this.route('confirm')
          this.route('success')
          this.route('error', { path: '/error/:uuid' })
        })
      })
      this.route('certificates')
      this.route('subscription')
    })

    this.route('lessons', function () {
      this.route('fast-phonics', function () {
        this.route('previews')
        this.route('resources')
        this.route('videos')
      })
      this.route('reading-eggs', function () {
        this.route('previews')
      })
      this.route('reading-eggspress', function () {
        this.route('previews')
      })
      this.route('mathseeds', function () {
        this.route('previews')
      })
      this.route('mathseeds-prime', function () {
        this.route('previews')
      })
      this.route('writing-legends', function () {
        this.route('previews')
      })
    })

    this.route('assignments', { resetNamespace: true }, function () {
      this.route('product', { path: ':product' }, function () {
        this.route('create')
        this.route('manage', function () {
          this.route('my-students', function () {
            this.route('student', { path: ':student_id' })
          })
          this.route('all-students', function () {
            this.route('student', { path: ':student_id' })
          })
          this.route('current', function () {
            this.route('show', { path: ':assignment_id' })
            this.route('edit', { path: 'edit/:assignment_id' })
          })
          this.route('past')
        })
      })
    })

    this.route('reporting', { resetNamespace: true }, function () {
      // /school/1234 OR /teacher/1234 OR /school-class/1234
      this.route('ui-scope', { path: '/:ui_scope_name/:ui_scope_id' }, function () {
        this.route('writing-legends', function () {
          this.route('dashboard-table')
          this.route('course-progress')
          this.route('time-on-task')
          this.route('quizzes-completed')
          this.route('recent-writing')
          this.route('spelling')
          this.route('vocabulary', function () {
            this.route('bank', function () {
              this.route('new-words')
              this.route('language-gems')
            })
            this.route('overused-words-analyser')
            this.route('language-gems-analyser')
          })
        })
        this.route('mathseeds-prime', function () {
          this.route('dashboard-table')
          this.route('dashboard-student', { path: '/student/:student_id' }, function () {
            // {} creates the implicit index
          })
        })
        this.route('maths', { path: 'mathseeds' }, function () {
          this.route('dashboard', function () {
            this.route('table')
          })
          this.route('summary', function () {
            this.route('table')
          })
          this.route('time-on-task')
          this.route('standards-performance')
          this.route('lesson-performance')
          this.route('course-progress', function () {
            this.route('lessons') // class-progress
          })
          this.route('skills-mastered', function () {
            // this.route('student', { path: '/student/:student_id' }, function () {
            //   this.route('table')
            // })
            this.route('cohort', function () {
              this.route('students-results')
              // this.route('detailed-class-results')
            })
          })
          this.route('assessment-scores') // quizzes-completed
          this.route('awards-earned') // certificates-earned
          this.route('fluency-sprints', function () {
            this.route('student', { path: '/student/:student_id' }, function () {
              this.route('table')
            })
            this.route('teacher', function () {
              this.route('teachers')
              this.route('student-results')
              this.route('student-results-overview')
            })
          })
          this.route('driving-tests')
          this.route('student-summary', { path: '/student-summary/:student_id' }, function () {
            // for individual student only
            this.route('table')
          })
        })
        this.route('fast-phonics', function () {
          this.route('dashboard', function () {
            this.route('table')
            this.route('student', { path: '/student/:student_id' }, function () {
              this.route('table')
            })
          })
          this.route('progress', function () {
            this.route('student', { path: '/student/:student_id' }, function () {
              this.route('table')
            })
            this.route('review', function () {
              this.route('teachers')
              this.route('students')
            })
          })
          this.route('time-on-task')
          this.route('standards-performance')
          this.route('lesson-performance')
        })
        this.route('rex', { path: 'reading-eggspress' }, function () {
          this.route('dashboard', function () {
            this.route('table')
            this.route('student', { path: '/student/:student_id' }, function () {
              this.route('comprehension-lesson-progress', function () {})
              this.route('spelling-lesson-progress', function () {})
              this.route('assessments', function () {})
              this.route('assignments', function () {})
              this.route('books-read', function () {})
            })
          })
          this.route('summary', function () {
            this.route('table')
          })
          this.route('time-on-task')
          this.route('standards-performance')
          this.route('lesson-performance')
          this.route('course-progress', function () {
            this.route('my-lessons') // class-progress (comprehension is my_lessons)
            this.route('spelling')
          })
          this.route('assessment-scores') // assessments-completed
          this.route('awards-earned')
          this.route('stadium-events')
          this.route('quiz-scores') // quizzes-completed
          this.route('books-read', function () {
            // books-read
            this.route('by-genre') // books-read/by-genre
            this.route('by-level') // books-read/by-level
          })
          this.route('lexile-details') // lexile details / averages
          this.route('student-summary', { path: '/student-summary/:student_id' }, function () {
            // {} creates the implicit index
          })
          this.route('read-aloud-fluency', function () {
            this.route('student', { path: '/student/:student_id' })
          })
        })
        // re
        this.route('re', { path: 'reading-eggs' }, function () {
          this.route('dashboard', function () {
            this.route('table')
          })
          this.route('time-on-task')
          this.route('standards-performance')
          this.route('lesson-performance')
          this.route('course-progress', function () {
            this.route('reading') // comprehension
            this.route('spelling') // spelling
          })
          this.route('driving-tests')
          this.route('stories-written')
          this.route('storylands')
          this.route('assessment-scores') // Quiz scores
          this.route('lexile-details') // lexile details / averages
          this.route('books-read') // Books read
          this.route('skills-mastered', function () {
            // this.route('student', { path: '/student/:student_id' }, function () {
            //   this.route('table')
            // })
            this.route('cohort', function () {
              this.route('students-results')
              // this.route('detailed-class-results')
            })
          })
          this.route('awards-earned') // certificates earned
          this.route('student-summary', { path: '/student-summary/:student_id' }, function () {
            // for individual student only
            this.route('table')
            this.route('course-progress', function () {
              this.route('reading') // class-progress (comprehension is my_lessons)
              this.route('spelling')
            })
            this.route('driving-tests')
            this.route('stories-written')
          })
          this.route('summary', function () {
            this.route('table')
          })
        })
      })
    })

    this.route('quick-links', function () {
      this.route('fast-phonics')
      this.route('teacher-guides')
      this.route('research-reports')
      this.route('case-studies')
    })

    this.route('long-writes', function () {
      this.route('index', { path: '/' })
      this.route('previews', { path: '/previews/:activity_id' })
      this.route('submission', { path: '/submission/:snapshot_id/activity/:activity_id/student/:student_id' })
    })

    this.route('writing-ideas', function () {
      this.route('index', { path: '/' })
      this.route('previews', { path: '/previews/:activity_id' })
      this.route('submission', { path: '/submission/:snapshot_id/activity/:activity_id/student/:student_id' })
    })

    this.route('contact-us', function () {
      this.route('index', { path: '/' })
      this.route('submitted')
    })
  })
})
